import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import type { RootState } from '@/src/store'
import { getBhyvePrimaryContextTitle } from './bhyveAppCrumbsModel'

/** Current page short title for mobile bottom bar (matches breadcrumb “current” segment). */
export function useBhyvePrimaryContextTitle(): string {
  const router = useRouter()
  const pathname = router.pathname
  const pathForSegments = router.asPath.split('?')[0] ?? router.pathname
  const idParam = router.query.id

  const restaurantRecord = useSelector((s: RootState) => {
    const { restoData, restoDataWithUsers } = s.gyg365RestoList

    return restoDataWithUsers ?? restoData
  })

  const franchiseRecord = useSelector((s: RootState) => s.gyg365FranchiseList.franchiseData)

  return useMemo(
    () => getBhyvePrimaryContextTitle({ pathname, pathForSegments, idParam, restaurantRecord, franchiseRecord }),
    [pathname, pathForSegments, idParam, restaurantRecord, franchiseRecord]
  )
}
